import { ThunkAction } from "redux-thunk";
import { AppStateType } from "..";
import {
  SET_IS_TAGS_LOADING_IN_PROGRESS,
  SET_TAGS,
  SET_TOTAL_TAGS,
  SET_IS_TAG_ADDING_IN_PROGRESS,
  SET_TAG,
  SET_IS_TAG_UPDATE_IN_PROGRESS,
  SET_ALL_TAGS,
  SET_IS_CREATING_SPECIFIC_PAGE_PROMT_IN_PROGRESS,
  SET_IS_LOADING_SPECIFIC_PAGE_PROMT_IN_PROGRESS,
  SET_SPECIFIC_PAGE_PROMTS,
  SET_IS_DELETING_SPECIFIC_PAGE_PROMT_IN_PROGRESS,
} from "../reducers/tagReducer";
import { FormInstance, notification } from "antd";
import { ISpecificPagePromt, ITag } from "../../types";
import { tagsApi } from "../../api";

type SetIsTagsLoadingInProgress = {
  type: typeof SET_IS_TAGS_LOADING_IN_PROGRESS;
  payload: { isTagsLoadingInProgress: boolean };
};

type SetTags = {
  type: typeof SET_TAGS;
  payload: { tags: ITag[] };
};

type SetTag = {
  type: typeof SET_TAG;
  payload: { tag: ITag };
};

type SetTotalTags = {
  type: typeof SET_TOTAL_TAGS;
  payload: { totalTags: number };
};

type SetIsTagAddingInProgress = {
  type: typeof SET_IS_TAG_ADDING_IN_PROGRESS;
  payload: { isTagAddingInProgress: boolean };
};

type SetIsTagUpdateInProgress = {
  type: typeof SET_IS_TAG_UPDATE_IN_PROGRESS;
  payload: { isTagUpdateInProgress: boolean };
};

type SetAllTags = {
  type: typeof SET_ALL_TAGS;
  payload: { allTags: ITag[] };
};

type SetIsCreatingSpecificPagePromtInProgress = {
  type: typeof SET_IS_CREATING_SPECIFIC_PAGE_PROMT_IN_PROGRESS;
  payload: { isCreatingSpecificPagePromtInProgress: boolean };
};

type SetIsLoadingSpecificPagePromtInProgress = {
  type: typeof SET_IS_LOADING_SPECIFIC_PAGE_PROMT_IN_PROGRESS;
  payload: { isLoadingfSpecificPagePromtInProgress: boolean };
};

type SetSpecificPagePromts = {
  type: typeof SET_SPECIFIC_PAGE_PROMTS;
  payload: { specificPagePromts: ISpecificPagePromt[] };
};

type SetIsDeletingSpecificPagePromtInProgress = {
  type: typeof SET_IS_DELETING_SPECIFIC_PAGE_PROMT_IN_PROGRESS;
  payload: { isDeletingSpecificPagePromtInProgress: boolean };
};

export type TagActionsTypes =
  | SetIsTagsLoadingInProgress
  | SetTags
  | SetTotalTags
  | SetIsTagAddingInProgress
  | SetTag
  | SetIsTagUpdateInProgress
  | SetAllTags
  | SetIsCreatingSpecificPagePromtInProgress
  | SetIsLoadingSpecificPagePromtInProgress
  | SetSpecificPagePromts
  | SetIsDeletingSpecificPagePromtInProgress;

export const setIsTagsLoadingInProgress = (
  isTagsLoadingInProgress: boolean
): SetIsTagsLoadingInProgress => ({
  type: SET_IS_TAGS_LOADING_IN_PROGRESS,
  payload: { isTagsLoadingInProgress },
});

export const setIsTagAddingInProgress = (
  isTagAddingInProgress: boolean
): SetIsTagAddingInProgress => ({
  type: SET_IS_TAG_ADDING_IN_PROGRESS,
  payload: { isTagAddingInProgress },
});

export const setIsTagUpdateInProgress = (
  isTagUpdateInProgress: boolean
): SetIsTagUpdateInProgress => ({
  type: SET_IS_TAG_UPDATE_IN_PROGRESS,
  payload: { isTagUpdateInProgress },
});

export const setTotalTags = (totalTags: number): SetTotalTags => ({
  type: SET_TOTAL_TAGS,
  payload: { totalTags },
});

export const setTags = (tags: ITag[]): SetTags => ({
  type: SET_TAGS,
  payload: { tags },
});

export const setTag = (tag: ITag): SetTag => ({
  type: SET_TAG,
  payload: { tag },
});

export const setAllTags = (allTags: ITag[]): SetAllTags => ({
  type: SET_ALL_TAGS,
  payload: { allTags },
});

export const setIsCreatingSpecificPagePromtInProgress = (
  isCreatingSpecificPagePromtInProgress: boolean
): SetIsCreatingSpecificPagePromtInProgress => ({
  type: SET_IS_CREATING_SPECIFIC_PAGE_PROMT_IN_PROGRESS,
  payload: { isCreatingSpecificPagePromtInProgress },
});

export const setIsLoadingSpecificPagePromtInProgress = (
  isLoadingfSpecificPagePromtInProgress: boolean
): SetIsLoadingSpecificPagePromtInProgress => ({
  type: SET_IS_LOADING_SPECIFIC_PAGE_PROMT_IN_PROGRESS,
  payload: { isLoadingfSpecificPagePromtInProgress },
});

export const setIsDeletingSpecificPagePromtInProgress = (
  isDeletingSpecificPagePromtInProgress: boolean
): SetIsDeletingSpecificPagePromtInProgress => ({
  type: SET_IS_DELETING_SPECIFIC_PAGE_PROMT_IN_PROGRESS,
  payload: { isDeletingSpecificPagePromtInProgress },
});

export const setSpecificPagePromts = (
  specificPagePromts: ISpecificPagePromt[]
): SetSpecificPagePromts => ({
  type: SET_SPECIFIC_PAGE_PROMTS,
  payload: { specificPagePromts },
});

export type TagThunkType = ThunkAction<
  Promise<void>,
  AppStateType,
  unknown,
  TagActionsTypes
>;

export const getTags =
  (page: number): TagThunkType =>
  async (dispatch, getState) => {
    try {
      dispatch(setIsTagsLoadingInProgress(true));
      const response = await tagsApi.loadTags(page);
      if (response.status === "success") {
        console.log("response", response);
        dispatch(setTotalTags(response?.totalTags || 0));
        dispatch(setTags(response?.tags || []));
      }
    } catch (e) {
      notification.error({
        message: "Error",
        description: "Error loading list of tags",
      });
    } finally {
      dispatch(setIsTagsLoadingInProgress(false));
    }
  };

export const getAllTags = (): TagThunkType => async (dispatch, getState) => {
  try {
    dispatch(setIsTagsLoadingInProgress(true));
    const response = await tagsApi.loadAllTags();
    if (response.status === "success") {
      dispatch(setAllTags(response?.tags || []));
    }
  } catch (e) {
    notification.error({
      message: "Error",
      description: "Error loading list of all tags",
    });
  } finally {
    dispatch(setIsTagsLoadingInProgress(false));
  }
};

export const getOneTag =
  (id: string): TagThunkType =>
  async (dispatch, getState) => {
    try {
      dispatch(setIsTagsLoadingInProgress(true));
      const response = await tagsApi.loadOneTag(id);
      if (response.status === "success") {
        console.log("response", response);
        dispatch(setTag(response?.tag || null));
      }
    } catch (e) {
      notification.error({
        message: "Error",
        description: "Error loading tag info",
      });
    } finally {
      dispatch(setIsTagsLoadingInProgress(false));
    }
  };

export const updateTag =
  (
    id: string,
    tag: ITag,
    specificPageUpdateField: { [param: string]: string }
  ): TagThunkType =>
  async (dispatch, getState) => {
    try {
      dispatch(setIsTagUpdateInProgress(true));
      const response = await tagsApi.updateOneTag(id, tag);
      if (response.status === "success") {
        console.log("response", response);
        dispatch(setTag(response?.tag || null));
        if (Object.keys(specificPageUpdateField).length > 0) {
          dispatch(updateSpecificPagePromts(specificPageUpdateField));
        }
        notification.success({
          message: "Success",
          description: "Tag updated",
        });
        dispatch(loadSpecificPagePromts(id));
      }
    } catch (e) {
      notification.error({
        message: "Error",
        description: "Error loading tag info",
      });
    } finally {
      dispatch(setIsTagUpdateInProgress(false));
    }
  };

export const addTag =
  (
    tagName: string,
    fieldInDb: string,
    isGenerateByAi: boolean,
    aiPromt: string | undefined,
    isImage: boolean | undefined,
    form: FormInstance<any> | undefined
  ): TagThunkType =>
  async (dispatch, getState) => {
    try {
      dispatch(setIsTagAddingInProgress(true));
      const response = await tagsApi.addTag(
        tagName,
        fieldInDb,
        isGenerateByAi,
        aiPromt,
        isImage
      );
      if (response.status === "success") {
        console.log("response", response);
        dispatch(getTags(1));
        notification.success({
          message: "Success",
          description: "Tag added",
        });
        form?.resetFields();
      } else if (response.status === "already_exist") {
        notification.error({
          message: "Error",
          description: "Tag already exist",
        });
      }
    } catch (e) {
      notification.error({
        message: "Error",
        description: "Error adding tag",
      });
    } finally {
      dispatch(setIsTagAddingInProgress(false));
    }
  };

export const loadSpecificPagePromts =
  (id: string): TagThunkType =>
  async (dispatch, getState) => {
    try {
      dispatch(setIsLoadingSpecificPagePromtInProgress(true));
      const response = await tagsApi.getSpecificPagePromts(id);
      if (response.status === "success") {
        dispatch(setSpecificPagePromts(response.promts));
      }
    } catch (e) {
      notification.error({
        message: "Error",
        description: "Error create specific page promt ",
      });
    } finally {
      dispatch(setIsLoadingSpecificPagePromtInProgress(false));
    }
  };

export const createSpecificPagePromt =
  (promt: string, page: string, id: string): TagThunkType =>
  async (dispatch, getState) => {
    try {
      dispatch(setIsCreatingSpecificPagePromtInProgress(true));
      const response = await tagsApi.newSpecificPagePromt(promt, page, id);
      if (response.status === "success") {
        dispatch(loadSpecificPagePromts(id));
        notification.success({
          message: "Success",
          description: "Specific page promt added",
        });
      }
    } catch (e) {
      notification.error({
        message: "Error",
        description: "Error create specific page promt ",
      });
    } finally {
      dispatch(setIsCreatingSpecificPagePromtInProgress(false));
    }
  };

export const updateSpecificPagePromts =
  (specificPageUpdateField: { [param: string]: string }): TagThunkType =>
  async (dispatch, getState) => {
    try {
      await tagsApi.updSpecificPagePromts(specificPageUpdateField);
    } catch (e) {
      notification.error({
        message: "Error",
        description: "Error update specific page promt ",
      });
    }
  };

export const deleteSpecificPagePromt =
  (id: string, tagId: string): TagThunkType =>
  async (dispatch, getState) => {
    try {
      dispatch(setIsDeletingSpecificPagePromtInProgress(true));
      const response = await tagsApi.removeSpecificPagePromt(id);
      if (response.status === "success") {
        dispatch(loadSpecificPagePromts(tagId));
        notification.success({
          message: "Success",
          description: "Specific page promt deleted",
        });
      }
    } catch (e) {
      notification.error({
        message: "Error",
        description: "Error delete specific page promt ",
      });
    } finally {
      dispatch(setIsDeletingSpecificPagePromtInProgress(false));
    }
  };
